<template>
  <div class="payservice">
    <div>////支付服务头部</div>

    <div class="order_info">
      <ul>
        <li class>
          <span>订单编号:</span>
          <span>125678997</span>
        </li>

        <li class>
          <span>下单时间:</span>
          <span>2019-09-19</span>
        </li>

        <li class>
          <span>订单金额:</span>
          <span class="col_E97620">￥525.00</span>
        </li>

        <li class>
          <span>订单状态:</span>
          <span>未支付</span>
        </li>

        <li class>
          <span style="width:40%;">距离服务时间还剩:</span>
          <span class="col_5E5E5E">1天12小时34分</span>
        </li>
      </ul>
    </div>

    <div class="order_info">
      <ul class="store_box">
        <li class>
          <span>服务门店:</span>
          <span>柳安堂 (坂田店)</span>
        </li>

        <li class>
          <span>服务人数:</span>
          <span>1位</span>
        </li>

        <li class>
          <span>服务床位:</span>
          <span>1号床位</span>
        </li>

        <li class>
          <span>服务技师:</span>
          <span>成技师</span>
        </li>

        <li class>
          <span>服务时间:</span>
          <span>2019-09-20 16:00</span>
        </li>

        <li class>
          <span>联系人:</span>
          <span>李女士</span>
        </li>

        <li class>
          <span>手机号:</span>
          <span>13778900987</span>
        </li>
      </ul>

      <div class="btn_box">
        <button class="cancel_btn" @click="cancel">取消订单</button>
        <button class="pay_btn">立即付款</button>
      </div>
    </div>

    <van-popup v-model="cancelrs_show" closeable position="bottom" class="popup">
      <p class="cancel_label">取消订单</p>
      <div class="time_tip flex_center">
        <span class="iconfont icon-tishi"></span> 距离服务时间还剩3小时，可取消订单
      </div>

      <p class="respon_label">请选择取消订单原因</p>

      <van-radio-group v-model="cancel_radio">
        <van-cell-group>
          <van-cell title="时间冲突" clickable @click="radio = '0'">
            <van-radio slot="right-icon" name="0" />
          </van-cell>
          <van-cell title="不想服务了" clickable @click="radio = '1'">
            <van-radio slot="right-icon" name="1" />
          </van-cell>
          <van-cell title="其他原因" clickable @click="radio = '2'">
            <van-radio slot="right-icon" name="2" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <div class="other" v-if="cancel_radio==2">
        <input type="text" />
      </div>

      <div class="btn_box">
        <button class="ckcancel_btn">确认取消</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "payservice",
  components: {},
  data() {
    return {
      cancelrs_show: 0,
      cancel_radio: "2"
    };
  },
  mounted() {},
  methods: {
    cancel() {
      this.cancelrs_show = 1;
    }
  }
};
</script>
<style scoped>
.order_info {
  margin-top: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.7rem;
  color: #4b4d4d;
  background-color: white;
}
.order_info span:last-child {
  color: #929393;
}
.order_info li {
  padding: 0.25rem 0;
}
.order_info li span:first-child {
  width: 25%;
  display: block;
  float: left;
}
.order_info li span:last-child {
  width: 100%;
  display: block;
}
.col_E97620 {
  color: #e97620 !important;
}
.store_box {
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #eee;
}
.btn_box {
  margin: 2rem 0;
  text-align: center;
}
.cancel_btn {
  border-radius: 5px;
  border: 1px solid #a0a0a0;
  font-size: 0.8rem;
  color: #7b7979;
  padding: 0.5rem 1.3rem;
  margin: 0 0.5rem;
}
.pay_btn {
  border-radius: 5px;
  border: 1px solid #45b9bc;
  font-size: 0.8rem;
  color: #45b9bc;
  padding: 0.5rem 1.3rem;
  margin: 0 0.5rem;
}
.popup {
}
.cancel_label {
  padding: 1rem 0;
  font-size: 0.9rem;
  color: #434343;
  text-align: center;
}
.time_tip {
  background-color: #effbfb;
  color: #45b9bc;
  font-size: 0.6rem;
  padding: 0.25rem 0.75rem;
}
.icon-tishi {
  padding-top: 0.2rem;
}
.respon_label {
  font-size: 0.7rem;
  color: #989696;
  padding: 1rem 0.75rem 0.5rem;
}
.other {
  margin: 0.5rem 0.75rem;
  border: 1px solid #eee;
}
.other input {
  width: 100%;
  font-size: 0.75rem;
}
.van-radio-group {
  padding: 0 0.75rem;
  font-size: 0.7rem;
  color: #595757;
}
.van-radio__icon {
  height: 1rem;
}
.ckcancel_btn {
  background-color: #45b9bc;
  color: white;
  border-radius: 4px;
  padding: 0.5rem 0;
  width: 70%;
}
.col_5E5E5E{
  color:#5E5E5E !important;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/payservice.vue